var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39102 13.6223C4.39305 13.8985 4.61856 14.1207 4.89469 14.1186L7.89461 14.0965C8.17075 14.0945 8.39625 14.3167 8.39828 14.5928L8.40566 15.5928C8.4077 15.8689 8.1855 16.0944 7.90936 16.0964L2.9095 16.1333C2.63337 16.1354 2.40786 15.9132 2.40583 15.637L2.32468 4.63732C2.32264 4.36119 2.09714 4.13899 1.821 4.14103L0.528146 4.15056C0.0827061 4.15385 -0.144345 3.61694 0.168305 3.29964L2.94052 0.486221C3.13434 0.289525 3.45091 0.28719 3.64761 0.481005L6.46103 3.25322C6.77833 3.56587 6.55922 4.10607 6.11378 4.10936L4.82092 4.1189C4.54479 4.12093 4.32259 4.34644 4.32462 4.62257L4.39102 13.6223ZM14.3244 4.5488C14.3223 4.27267 14.0968 4.05047 13.8207 4.0525L10.8208 4.07463C10.5446 4.07667 10.3191 3.85447 10.3171 3.57834L10.3097 2.57836C10.3077 2.30223 10.5299 2.07673 10.806 2.07469L15.8059 2.0378C16.082 2.03577 16.3075 2.25797 16.3095 2.5341L16.3907 13.5338C16.3927 13.8099 16.6182 14.0321 16.8944 14.0301L18.1872 14.0206C18.6327 14.0173 18.8597 14.5542 18.5471 14.8715L15.7748 17.6849C15.581 17.8816 15.2645 17.8839 15.0678 17.6901L12.2543 14.9179C11.937 14.6053 12.1561 14.0651 12.6016 14.0618L13.8944 14.0522C14.1706 14.0502 14.3928 13.8247 14.3907 13.5486L14.3244 4.5488Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.f322457d.svg";
export { ForwardRef as ReactComponent };